export default {
  categories: 'Categorias',
  segments: 'Segmentos',
  businesses: 'Compañías',
  active: 'Activo',
  inactive: 'Inactivo',
  noBusinessesCreated: 'No se han creado {business}',
  newBusiness: 'Nuevo negocio',
  editBusiness: 'Editar negocio',
  businessUrl: 'Url del negocio',
  segment: 'Segmento',
  insertExtraDataName: 'Ingresa el nombre del dato adicional',
  insertExtraDataValues: 'Ingresa los valores del dato adicional',
  delete: 'Borrar',
  addExtraData: 'Agregar un dato adicional',
  businessSuccessfullyCreated: '{business} creado/a correctamente',
  businessSuccessfullyEdited: '{business} modificado/a correctmente',
  addNewBusiness: 'Agregar nuevo {business}',
  uploadPhoto: 'Subir foto',
  doYouWantToDeleteThisContact: '¿Desea borrar este contacto?',
  deleteContact: 'Borrar contacto',
  contactSuccessfullyDeleted: 'Contacto borrado correctamente',
  doYouWantToDeleteThisBusiness: '¿Deseas borrar este/a {business}?',
  deleteBusiness: 'Borrar {business}',
  businessSuccessfullyDeleted: '{business} borrado/a correctamente',
  errorLoadingTheBusiness: 'Ocurrió un error cargando el/la {business}',
  addContact: 'Agregar contacto',
  nameOfTheBusiness: 'Nombre del {business}',
  noCategories: 'Sin categorias',
  noLocation: 'Sin localización',
  noAddress: 'Sin dirección',
  noSegment: 'Sin segmento',
  contactSuccessfullyAdded: 'Contacto agregado correctamente',
  contacts: 'Contactos',
  noRoles: 'Sin roles',
  loadingBusinessContacts: 'Cargando los contactos del/la {business}',
  noBusinessContacts: 'Este/a {business} no tiene contactos'
}
